var scope_0 = require('/home/runner/work/ciriarte.github.io/ciriarte.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/32acb93d657494f75f34f0984d7f027c.js').default;
var scope_1 = require('/home/runner/work/ciriarte.github.io/ciriarte.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9e2baac5b338b9b1b4c4698b3317778e.js').default;
var scope_2 = require('/home/runner/work/ciriarte.github.io/ciriarte.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    